import React, { createContext, useState, useEffect } from "react"
import { LABEL_MAP } from "./articleLabel.data"

const labelArr = Array.from(LABEL_MAP, ([key, value]) => ({ key, value }))

export const articleContext = createContext({
  articleDatas: [],
  LABEL_MAP: new Map(),
  labelArr: [],
})

const ArticleProvider = ({ children, articleDatas }) => {
  return (
    <articleContext.Provider
      value={{
        articleDatas,
        LABEL_MAP,
        labelArr,
      }}
    >
      {children}
    </articleContext.Provider>
  )
}
export default ArticleProvider
